// The warehouse bay this device prints to: a desk station's Bay-Name
// header, or the bay a phone or iPad picked on the scanning screen. The
// layout puts it in a <meta name="laced-bay"> for staff (blank = no bay).
// Anything that prints to a bay's printers should be disabled without one.
export const currentBayName = (): string | null => {
  if (typeof document === 'undefined') return null

  return (
    document
      .querySelector('meta[name="laced-bay"]')
      ?.getAttribute('content')
      ?.trim() || null
  )
}

export const hasBay = () => Boolean(currentBayName())

export const NO_BAY_PRINT_HINT =
  'Printing needs a bay: pick one on the Inbound Scanning screen.'
